import { Dimensions, OnExportReadyCallback } from '@ecosystem/export-utils';
import DoubleBarChart from '@components/design/migrated/DoubleBarChart/DoubleBarChart';
import React from 'react';
import { GrowthTypes } from '@components/comparison-growth-selector/Types';
import { CategoryLeaderboardPg } from '@models/CategoryLeaderboard';
import {
  constructCurrencyLabel,
  formatLabelIntoRevenuePriceTitle,
  isRevenueType,
} from '@utils/currencyUtils/CurrencyUtils';
import { FactRevenue } from '@utils/pageConfig/Types';
import * as styles from './PerformanceSegmentChart.module.scss';
import { getChartOptions } from './PerformanceSegmentChartConfig';
import { KpiDropdownOption } from './Types';
import { ChartScales } from '../performance-segment-mulitple-chart/hooks/UsePerformanceSegmentMultipleChartScales';
import { useInitDoubleBarChart } from '@data-visualization/products-leaderboard-bar-chart/useInitDoubleBarChart';

type Props = {
  categoryLeaderboardPg: CategoryLeaderboardPg[];
  selectedGrowthType: GrowthTypes;
  selectedKpi: KpiDropdownOption;
  factRevenue: FactRevenue;
  onExportReady: OnExportReadyCallback;
  chartScales?: ChartScales;
  dimensions?: Dimensions;
  index?: number;
};

const PerformanceSegmentChart: React.FC<Props> = ({
  categoryLeaderboardPg,
  selectedGrowthType,
  selectedKpi,
  factRevenue,
  onExportReady,
  chartScales,
  dimensions,
  index,
}) => {
  const kpiLabel = isRevenueType(selectedKpi.value)
    ? formatLabelIntoRevenuePriceTitle(selectedKpi.label.toString(), constructCurrencyLabel(factRevenue))
    : selectedKpi.label;

  const chartOptions = getChartOptions({
    kpiKey: selectedKpi.value,
    kpiLabel: kpiLabel,
    selectedGrowthType: selectedGrowthType,
    categoryLeaderboardPg: categoryLeaderboardPg,
    factRevenue: factRevenue,
  });

  const { options, chartCallback } = useInitDoubleBarChart({
    chartOptions,
    chartScales,
    index,
    onExportReady,
    dimensions,
  });

  return (
    <div data-testid="performance-bar-chart" className={styles.Segmentation__Chart__Container}>
      <DoubleBarChart options={options} callback={chartCallback} />
    </div>
  );
};

export default PerformanceSegmentChart;
